module.exports = __webpack_public_path__ + "static/medicineicon-cac09f79f6fa0e536fabe928f55ec7b9.jpg";